export const blog = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <path
      d='M13 3H16C16.2652 3 16.5196 3.10536 16.7071 3.29289C16.8946 3.48043 17 3.73478 17 4V15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17C14.4696 17 13.9609 16.7893 13.5858 16.4142C13.2107 16.0391 13 15.5304 13 15V2C13 1.73478 12.8946 1.48043 12.7071 1.29289C12.5196 1.10536 12.2652 1 12 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V14C1 14.7956 1.31607 15.5587 1.87868 16.1213C2.44129 16.6839 3.20435 17 4 17H15M5 5H9M5 9H9M5 13H9'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const partners = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7.99998 3.333C7.99998 4.62148 6.95546 5.666 5.66698 5.666C4.3785 5.666 3.33398 4.62148 3.33398 3.333C3.33398 2.04452 4.3785 1 5.66698 1C6.95546 1 7.99998 2.04452 7.99998 3.333Z'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M10.333 11.7328C10.333 13.5328 8.244 14.9998 5.666 14.9998C3.088 14.9998 1 13.5368 1 11.7328C1 9.9288 3.089 8.4668 5.667 8.4668C8.245 8.4668 10.333 9.9288 10.333 11.7328Z'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M12.939 5.51133C12.939 6.28453 12.3122 6.91133 11.539 6.91133C10.7658 6.91133 10.139 6.28453 10.139 5.51133C10.139 4.73813 10.7658 4.11133 11.539 4.11133C11.9103 4.11133 12.2664 4.25883 12.5289 4.52138C12.7915 4.78393 12.939 5.14003 12.939 5.51133Z'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M12.2 14.0665C13.6138 14.1826 14.8596 13.144 15 11.7325C14.8591 10.3213 13.6134 9.28338 12.2 9.39949'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const docs = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M5.308 1.00001H10.829C10.8863 1.00001 10.9433 1.00367 11 1.01101C13.2473 1.16817 14.9924 3.0332 15 5.28601V11.715C14.9917 14.0871 13.0641 16.0044 10.692 16H5.308C2.93551 16.0044 1.00772 14.0865 1 11.714V5.28601C1.00772 2.91353 2.93551 0.995581 5.308 1.00001Z'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M15 6.28672C15.5523 6.28672 16 5.839 16 5.28672C16 4.73443 15.5523 4.28672 15 4.28672V6.28672ZM11 5.28672H10C10 5.839 10.4477 6.28672 11 6.28672V5.28672ZM12 1.01172C12 0.459434 11.5523 0.0117188 11 0.0117188C10.4477 0.0117188 10 0.459434 10 1.01172H12ZM10 10.0007C10.5523 10.0007 11 9.553 11 9.00072C11 8.44843 10.5523 8.00072 10 8.00072V10.0007ZM4 8.00072C3.44772 8.00072 3 8.44843 3 9.00072C3 9.553 3.44772 10.0007 4 10.0007V8.00072ZM7 7.00072C7.55228 7.00072 8 6.553 8 6.00072C8 5.44843 7.55228 5.00072 7 5.00072V7.00072ZM4 5.00072C3.44772 5.00072 3 5.44843 3 6.00072C3 6.553 3.44772 7.00072 4 7.00072V5.00072ZM11 13.0007C11.5523 13.0007 12 12.553 12 12.0007C12 11.4484 11.5523 11.0007 11 11.0007V13.0007ZM4 11.0007C3.44772 11.0007 3 11.4484 3 12.0007C3 12.553 3.44772 13.0007 4 13.0007V11.0007ZM15 4.28672H11V6.28672H15V4.28672ZM12 5.28672V1.01172H10V5.28672H12ZM10 8.00072H4V10.0007H10V8.00072ZM7 5.00072H4V7.00072H7V5.00072ZM11 11.0007H4V13.0007H11V11.0007Z'
      fill='#566982'
    />
  </svg>
);

export const listings = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8 6.6L1 3.8L8 1L15 3.8L8 6.6Z'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M1.37139 11.2715C0.858607 11.0664 0.276637 11.3158 0.0715233 11.8286C-0.13359 12.3414 0.115826 12.9234 0.628609 13.1285L1.37139 11.2715ZM8 15L7.62861 15.9285C7.86702 16.0238 8.13298 16.0238 8.37139 15.9285L8 15ZM15.3714 13.1285C15.8842 12.9234 16.1336 12.3414 15.9285 11.8286C15.7234 11.3158 15.1414 11.0664 14.6286 11.2715L15.3714 13.1285ZM1.37139 7.07152C0.858607 6.86641 0.276637 7.11583 0.0715233 7.62861C-0.13359 8.14139 0.115826 8.72336 0.628609 8.92848L1.37139 7.07152ZM8 10.8L7.62861 11.7285C7.86702 11.8238 8.13298 11.8238 8.37139 11.7285L8 10.8ZM15.3714 8.92848C15.8842 8.72336 16.1336 8.14139 15.9285 7.62861C15.7234 7.11583 15.1414 6.86641 14.6286 7.07152L15.3714 8.92848ZM0.628609 13.1285L7.62861 15.9285L8.37139 14.0715L1.37139 11.2715L0.628609 13.1285ZM8.37139 15.9285L15.3714 13.1285L14.6286 11.2715L7.62861 14.0715L8.37139 15.9285ZM0.628609 8.92848L7.62861 11.7285L8.37139 9.87152L1.37139 7.07152L0.628609 8.92848ZM8.37139 11.7285L15.3714 8.92848L14.6286 7.07152L7.62861 9.87152L8.37139 11.7285Z'
      fill='#566982'
    />
  </svg>
);

export const contracts = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='16'
    viewBox='0 0 13 16'
    fill='none'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8.5 3C8.5 1.89543 7.60457 1 6.5 1C5.39543 1 4.5 1.89543 4.5 3H8.5Z'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M4.20711 8.29383C3.81658 7.9033 3.18342 7.9033 2.79289 8.29383C2.40237 8.68435 2.40237 9.31752 2.79289 9.70804L4.20711 8.29383ZM5.5 11.0009L4.79289 11.708C5.18342 12.0986 5.81658 12.0986 6.20711 11.708L5.5 11.0009ZM10.2071 7.70804C10.5976 7.31752 10.5976 6.68435 10.2071 6.29383C9.81658 5.9033 9.18342 5.9033 8.79289 6.29383L10.2071 7.70804ZM8.5 2.00093C7.94772 2.00093 7.5 2.44865 7.5 3.00093C7.5 3.55322 7.94772 4.00093 8.5 4.00093V2.00093ZM10.167 3.00093V4.00093C10.1777 4.00093 10.1884 4.00076 10.1991 4.00042L10.167 3.00093ZM12 4.71493H13C13 4.70329 12.9998 4.69164 12.9994 4.68L12 4.71493ZM12 13.2859L12.9994 13.3203C12.9998 13.3089 13 13.2974 13 13.2859H12ZM10.167 15.0009L10.1991 14.0015C10.1884 14.0011 10.1777 14.0009 10.167 14.0009V15.0009ZM2.833 15.0009V14.0009C2.82229 14.0009 2.81158 14.0011 2.80088 14.0015L2.833 15.0009ZM1 13.2869H0C0 13.2986 0.00020355 13.3102 0.000610471 13.3219L1 13.2869ZM1 4.71493L0.000610471 4.68C0.00020355 4.69164 0 4.70329 0 4.71493H1ZM2.833 3.00093L2.80088 4.00042C2.81158 4.00076 2.82229 4.00093 2.833 4.00093V3.00093ZM4.5 4.00093C5.05228 4.00093 5.5 3.55322 5.5 3.00093C5.5 2.44865 5.05228 2.00093 4.5 2.00093V4.00093ZM2.79289 9.70804L4.79289 11.708L6.20711 10.2938L4.20711 8.29383L2.79289 9.70804ZM6.20711 11.708L10.2071 7.70804L8.79289 6.29383L4.79289 10.2938L6.20711 11.708ZM8.5 4.00093H10.167V2.00093H8.5V4.00093ZM10.1991 4.00042C10.6272 3.98666 10.9856 4.32186 11.0006 4.74987L12.9994 4.68C12.9459 3.15029 11.6647 1.95228 10.1349 2.00145L10.1991 4.00042ZM11 4.71493V13.2859H13V4.71493H11ZM11.0006 13.2516C10.9859 13.6797 10.6273 14.0152 10.1991 14.0015L10.1349 16.0004C11.6653 16.0496 12.9468 14.8506 12.9994 13.3203L11.0006 13.2516ZM10.167 14.0009H2.833V16.0009H10.167V14.0009ZM2.80088 14.0015C2.37282 14.0152 2.01435 13.68 1.99939 13.252L0.000610471 13.3219C0.0540864 14.8516 1.33527 16.0496 2.86512 16.0004L2.80088 14.0015ZM2 13.2869V4.71493H0V13.2869H2ZM1.99939 4.74987C2.01435 4.32186 2.37283 3.98666 2.80088 4.00042L2.86512 2.00145C1.33527 1.95228 0.0540864 3.15029 0.000610471 4.68L1.99939 4.74987ZM2.833 4.00093H4.5V2.00093H2.833V4.00093Z'
      fill='#566982'
    />
  </svg>
);

export const bell = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='20'
    viewBox='0 0 18 20'
    fill='none'
  >
    <path
      d='M7 3C7 2.46957 7.21071 1.96086 7.58579 1.58579C7.96086 1.21071 8.46957 1 9 1C9.53043 1 10.0391 1.21071 10.4142 1.58579C10.7893 1.96086 11 2.46957 11 3C12.1484 3.54303 13.1274 4.38833 13.8321 5.4453C14.5367 6.50227 14.9404 7.73107 15 9V12C15.0753 12.6217 15.2954 13.2171 15.6428 13.7381C15.9902 14.2592 16.4551 14.6914 17 15H1C1.54494 14.6914 2.00981 14.2592 2.35719 13.7381C2.70457 13.2171 2.92474 12.6217 3 12V9C3.05956 7.73107 3.4633 6.50227 4.16795 5.4453C4.8726 4.38833 5.85159 3.54303 7 3M6 15V16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19C9.79565 19 10.5587 18.6839 11.1213 18.1213C11.6839 17.5587 12 16.7956 12 16V15'
      stroke='#566982'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const logout = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <g clip-path='url(#clip0_1771_17471)'>
      <path
        d='M9.393 11.25C9.59191 11.25 9.78268 11.329 9.92333 11.4697C10.064 11.6103 10.143 11.8011 10.143 12V14.25C10.143 14.8467 10.3801 15.419 10.802 15.841C11.224 16.2629 11.7963 16.5 12.393 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5H12.393C11.7963 1.5 11.224 1.73705 10.802 2.15901C10.3801 2.58097 10.143 3.15326 10.143 3.75V6C10.143 6.19891 10.064 6.38968 9.92333 6.53033C9.78268 6.67098 9.59191 6.75 9.393 6.75C9.19409 6.75 9.00332 6.67098 8.86267 6.53033C8.72202 6.38968 8.643 6.19891 8.643 6V3.75C8.64419 2.7558 9.03966 1.80267 9.74266 1.09966C10.4457 0.396661 11.3988 0.00119089 12.393 0H14.25C15.2442 0.00119089 16.1973 0.396661 16.9003 1.09966C17.6033 1.80267 17.9988 2.7558 18 3.75V14.25C17.9988 15.2442 17.6033 16.1973 16.9003 16.9003C16.1973 17.6033 15.2442 17.9988 14.25 18H12.393C11.3988 17.9988 10.4457 17.6033 9.74266 16.9003C9.03966 16.1973 8.64419 15.2442 8.643 14.25V12C8.643 11.8011 8.72202 11.6103 8.86267 11.4697C9.00332 11.329 9.19409 11.25 9.393 11.25Z'
        fill='#374957'
      />
      <path
        d='M0.849634 7.4087L4.28913 3.9692C4.35832 3.89757 4.44108 3.84043 4.53258 3.80112C4.62409 3.76182 4.7225 3.74113 4.82208 3.74026C4.92167 3.7394 5.02043 3.75837 5.1126 3.79608C5.20477 3.83379 5.28851 3.88948 5.35893 3.9599C5.42935 4.03032 5.48504 4.11406 5.52275 4.20624C5.56046 4.29841 5.57944 4.39717 5.57857 4.49675C5.57771 4.59634 5.55702 4.69475 5.51771 4.78625C5.4784 4.87776 5.42127 4.96052 5.34963 5.0297L2.15313 8.22695L13.4999 8.24945C13.6988 8.24945 13.8896 8.32847 14.0302 8.46912C14.1709 8.60977 14.2499 8.80054 14.2499 8.99945C14.2499 9.19836 14.1709 9.38913 14.0302 9.52978C13.8896 9.67043 13.6988 9.74945 13.4999 9.74945L2.10888 9.7262L5.35114 12.9692C5.42277 13.0384 5.47991 13.1211 5.51921 13.2126C5.55852 13.3042 5.57921 13.4026 5.58007 13.5022C5.58094 13.6017 5.56196 13.7005 5.52425 13.7927C5.48654 13.8848 5.43085 13.9686 5.36043 14.039C5.29001 14.1094 5.20627 14.1651 5.1141 14.2028C5.02193 14.2405 4.92317 14.2595 4.82358 14.2586C4.724 14.2578 4.62558 14.2371 4.53408 14.1978C4.44258 14.1585 4.35982 14.1013 4.29064 14.0297L0.851134 10.5902C0.429126 10.1685 0.191895 9.59638 0.191614 8.99976C0.191333 8.40314 0.428023 7.83084 0.849634 7.4087Z'
        fill='#374957'
      />
    </g>
    <defs>
      <clipPath id='clip0_1771_17471'>
        <rect
          width='18'
          height='18'
          fill='white'
          transform='matrix(-1 0 0 1 18 0)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const favorite = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='14'
    viewBox='0 0 15 14'
    fill='none'
  >
    <path
      d='M1.49486 8.01789L7.02534 13.2132C7.21585 13.3922 7.3111 13.4816 7.42341 13.5037C7.47399 13.5136 7.52601 13.5136 7.57659 13.5037C7.6889 13.4816 7.78415 13.3922 7.97466 13.2132L13.5051 8.0179C15.0612 6.55615 15.2502 4.15071 13.9414 2.46392L13.6954 2.14675C12.1298 0.128871 8.98721 0.467283 7.88712 2.77222C7.73173 3.09781 7.26827 3.09781 7.11288 2.77222C6.01279 0.467283 2.87023 0.128871 1.30464 2.14675L1.05856 2.46392C-0.250155 4.15071 -0.0611943 6.55615 1.49486 8.01789Z'
      fill='#3F4FE0'
    />
  </svg>
);

export const favoriteGray = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='14'
    viewBox='0 0 20 17'
    fill='none'
  >
    <path
      d='M2.45067 9.90821L9.40329 16.4395C9.64278 16.6644 9.76253 16.7769 9.90372 16.8046C9.9673 16.8171 10.0327 16.8171 10.0963 16.8046C10.2375 16.7769 10.3572 16.6644 10.5967 16.4395L17.5493 9.90821C19.5055 8.07059 19.743 5.0466 18.0978 2.92607L17.7885 2.52734C15.8203 -0.00942016 11.8696 0.416014 10.4867 3.31365C10.2913 3.72296 9.70868 3.72296 9.51333 3.31365C8.13037 0.416014 4.17972 -0.00941634 2.21154 2.52735L1.90219 2.92607C0.256947 5.0466 0.494498 8.07059 2.45067 9.90821Z'
      fill='#8794A5'
    />
  </svg>
);

export const sortDown = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='15'
    viewBox='0 0 19 15'
    fill='none'
  >
    <path
      d='M1 1.5H10M1 7.5H8M1 13.5H8M12 10.5L15 13.5L18 10.5M15 1.5V13.5'
      stroke='#110D28'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
